/// <amd-module name="Wit/WorkItemModel/WorkItem/LegacyField" />
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { FeatureFlags } from "Wit/Common/Constants/FeatureFlags";
import { ILegacyField } from "Wit/WorkItemModel/OM/ILegacyWorkItem";
import { IField, IFieldDefinition, IFieldSetValueOptions } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { convertFieldValueToDisplayString } from "./FieldUtils";

/// <amd-module name="Wit/WorkItemModel/WorkItem/LegacyField" />
export class LegacyField implements ILegacyField {
    private _value: any;
    private _field: IField;
    private fieldDefinition: IFieldDefinition;

    /**
     * remove with WebAccess.WorkItemTracking.DateParsingFixDisabled
     */
    private _pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext, field: IField, value: any) {
        this._value = value;
        this._field = field;
        this.fieldDefinition = field.fieldDefinition;
        this._pageContext = pageContext;
    }

    public getValue(): any {
        return this._value;
    }

    public getDisplayText(): string {
        const isDateParsingFixEnabled = !isFeatureFlagEnabled(this._pageContext, FeatureFlags.DateParsingFixDisabled, false);
        return convertFieldValueToDisplayString(this._value, isDateParsingFixEnabled) ?? "";
    }

    public setValue(value: any, options?: IFieldSetValueOptions): any {
        const retVal = this._field.workItem.setFieldValueById(this.fieldDefinition.id, value, options);
        this._value = value;
        return retVal;
    }

    public getAllowedValues(): string[]|undefined {
        return this._field.lists?.allowedValues[0].items;
    }
}
